(function ($) {
  Drupal.behaviors.pepStartImageVideoOverlayV1 = {
    attach: function (context, settings) {
      // showing video overlay
      $('.js-pep-start-image-video-overlay--v1', context).once().on('click', function() {
        var $this = $(this);
        var $videoIframe = $this.find('iframe');

        if ($videoIframe.length > 0) {
          // adding autoplay to play the video on overlay
          var iframe_src = $videoIframe.attr('src');

          if (iframe_src !== undefined && iframe_src.indexOf('autoplay=1') == -1) {
            iframe_src += '&autoplay=1';
          }
          // cloning youtube content as generic overlay removes content after
          // closing the overlay
          var iframe_clone = $videoIframe.clone();

          iframe_clone.attr('src', iframe_src);
          generic.overlay.launch({
            content: iframe_clone,
            cssClass: 'pep-start-video-popup'
          });
        }
      });
    }
  };
})(jQuery);
